// Module
var code = "<div role=\"alert\" aria-live=\"polite\" class=\"tm-alert tm-alert-{{type}}\"> <i class=\"tm-alert-icon fa {{getFontAwesomeClassName()}}\"></i> <p ng-transclude></p> </div> ";
// Exports
module.exports = code;